import { AbstractPreset, config } from "./AbstractPreset";

export default class RectangleRoundedrectangleNone extends AbstractPreset {
	getName(): string {
		return 'rectangleRoundedrectangleNone';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "rectangle",
				"presetShape": this.getName(),
				"primitives": {
					"width": 50,
					"length": 50
				},
			},
			"drillholes": {
				"type": "none"
			},
			"cutouts": [
				{
					"type": "shape",
					"shape": "rounded-rectangle",
					"primitives": {
						"width": 25,
						"length": 25,
						"radius": 2.5,
						"top_left_radius": 2.5,
						"top_right_radius": 2.5,
						"bottom_left_radius": 2.5,
						"bottom_right_radius": 2.5
					},
					"modifiers": {
						"use_individual_corners": false
					},
					"position": {
						"left": 250,
						"bottom": 250,
						"rotation": 0
					}
				}
			],
		};
	}
}
